export const GatorHucker ={
    // Header
    title: "Gator Hucker",
    subtitle: "Unreal Engine 5 | 3D",
    genre: "4x4 team Deathmatch",

    //Hero
    poster:"/Games/Gator Hucker/Library Capsule.png",
    releaseDate:"May 2026",
    studioName:"",
    teamSize:"15",
    platforms:"PC",
    responsiblities:[`Engineered and Implemented Online Newtworking with Epic Online Services (EOS)`,
        "Coordinated with Gameplay and UI leads to synchronize player statistics and replication.",
    ],
    engine:"Unreal Engine 5, C++ and Blueprints, EOS",
    projectLength:"~8 Months",

    //Description
    desc:[`Gator Hucker is a fast-paced brawler where you craft your own unique playstyle! You are alien alligators with wacky abilities locked in battle, in teams or a chaotic free-for-all!\n\nHuck into the arena with the help of cybernetically enhanced gorillas and cause chaos for glory and entertainment!,\n\nEngage in either 4 vs 4 team deathmatch or up to eight player free-for-all action! Navigate and explore an intricate gladiatorial arena.`,

        `Swap between your Bipedal and Quadrupedal forms and use their unique attributes to your advantage.\n\nTwo forms means twice the abilities! Try out all three special abilities for both the Bipedal and Quadrupedal forms for a new gameplay experience every time`,

        `After enough damage has been dealt, it's time to unleash your Ultimate Attack!\n\nChoose between the Super Laser or the Gorilla Strike to deal massive amounts of damage to your opponents!`,

        `Upon being defeated immediately rejoin the action by getting Hucked back into the arena by cybernetically enhanced gorillas!\n\nLand on opponents to deal incredible damage or land further away from the action, it's your choice!`
    ],
    img:["", "", "/Games/Gator Hucker/Super laser.png", "/Games/Gator Hucker/Hucking.png"

    ],
    contributions:[
        `Engineered and implemented online networking and Object-Oriented replication systems utilizing Epic Online Services (EOS),\nincluding private/ public lobbies and matchmaking.`,
        `Developed networking systems in Unreal 5 employing both C++ and Blueprints with a 15-member cross-functional team, \nadhering to version control protocols.`,
        `Coordinated with Gameplay and UI leads to synchronize player statistics and ensure 100% gameplay replication accuracy.`,
        `Managed version control hygiene and code review processes, enforcing strict quality gates before merging features to the main branch.`,
    ],

    //Home Screen Hero
    thumbnail:"./Thumbnails/GHuck_Thumbnail.png",
    shortDesc:"Eight Player fully online Team Deathmatch or Free For All game built in Unreal Engine 5.\nPlay as Alien Alligators with an array of fun abilities in this cartoony and casual 'Hero-shooter'!",
    badge:"./Project Badges/unreal-5-c++-&-blueprints.svg",
    url:"/projects/Gator Hucker",
    type:"Games",


    awards:"yes",
    awardImg:[""
    ],
    //Special Sections
    downloadable:"true",

    //Links
    githubURL:"",
    itchioURL:"https://gatorillagames.itch.io/gator-hucker",
    itchioEmbedURL:"https://itch.io/embed/4032432?dark=true",
    steamURL:"https://store.steampowered.com/app/4646860/Gator_Hucker/",
}
